import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/dianshiju', label: '电视剧' },
    { to: '/category/dianying', label: '电影' },
    { to: '/category/zongyi', label: '综艺' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold whitespace-nowrap transition-colors ${
              isScrolled ? 'text-foreground-900' : 'text-background-50'
            }`}>
              久久影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to || 
                (link.to.startsWith('/category/') && location.pathname.startsWith('/category/') && link.to === location.pathname);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : isScrolled
                        ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                        : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors text-foreground-600 hover:text-foreground-900 hover:bg-background-100">
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer">
              会员登录
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
          >
            <i className={`text-xl ${isScrolled ? 'text-foreground-900' : 'text-background-50'} ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to ||
                (link.to.startsWith('/category/') && location.pathname.startsWith('/category/') && link.to === location.pathname);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="border-t border-background-200/60 pt-2 mt-1">
              <button className="w-full px-4 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer text-center">
                会员登录
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}